export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'funnel_manage',
  'funnel_auto_message_manage',
  'label_manage',
  'product_manage',
  'quote_manage',
  'document_manage',
  'expedition_manage',
  'resume_manage',
  'failed_messages_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const FUNNEL_PERMISSIONS = 'funnel_manage';

export const FUNNEL_AUTO_MESSAGE_PERMISSIONS = 'funnel_auto_message_manage';

export const LABEL_PERMISSIONS = 'label_manage';

export const PRODUCT_PERMISSIONS = 'product_manage';

export const QUOTE_PERMISSIONS = 'quote_manage';

export const DOCUMENT_PERMISSIONS = 'document_manage';

export const EXPEDITION_PERMISSIONS = 'expedition_manage';

export const RESUME_PERMISSIONS = 'resume_manage';

export const FAILED_MESSAGES_PERMISSIONS = 'failed_messages_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  groups: {
    count: 'groupsCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  all: {
    count: 'allCount',
    permissions: [
      'administrator', // Apenas admin pode ver a aba "Todos"
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
    ],
  },
};
